import React from 'react'
import { Icon } from 'semantic-ui-react'

const Caret = ({ show }) =>
  show ? <Icon name="caret up" /> : <Icon name="caret down" />

export default Caret
